import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Textarea from 'react-textarea-autosize';

import commons from '@medflex/commons';

import Button from './Button';
import Modal from './Modal';

const PhysicianPagesLinkModal = ({
  isIndexed,
  isLoading,
  onClose = () => {},
  onSubmit = () => {},
  personalNote = '',
}) => {
  const { t } = useTranslation('components');
  const defaultValues = {
    personalNote: commons.constant.contactPage.personalNote.getText(),
  };
  const {
    formState,
    handleSubmit: wrapSubmit,
    register: registerFormElement,
    reset,
    setValue,
  } = useForm({
    defaultValues,
    mode: 'onChange',
  });

  const isSubmitDisabled = !formState.isValid || isLoading;

  useEffect(() => {
    setValue('personalNote', personalNote || commons.constant.contactPage.personalNote.getText());
  }, [personalNote]);

  useEffect(() => {
    setValue('shouldIndex', isIndexed);
  }, [isIndexed]);

  const handleSubmit = ({ shouldIndex, ...rest }) => {
    onSubmit({
      shouldIndex: !!shouldIndex,
      ...rest,
    });
  };

  const handleReset = () =>
    reset({ personalNote: commons.constant.contactPage.personalNote.getText() });

  return (
    <Modal
      showCloseButton
      onClickCloseButton={onClose}
      onClickOutside={onClose}
      title={t('PhysicianPagesLinkModal.title')}
    >
      <form onSubmit={wrapSubmit(handleSubmit)}>
        <div data-component="PhysicianPagesLinkModal">
          <label htmlFor="text">
            <span className="font-semibold mb-4 block">
              {t('PhysicianPagesLinkModal.personal_note.title')}
            </span>
          </label>

          <Textarea
            className="p-3 mb-2 resize-none border border-slate-500 focus:border-blue-500 rounded outline-none placeholder-slate-500 leading-tight w-full min-h-28"
            id="personalNote"
            maxLength={commons.constant.contactPage.personalNote.maxChars}
            minRows={3}
            name="personalNote"
            ref={registerFormElement({ required: true })}
          />

          <div className="flex justify-end">
            <button
              onClick={handleReset}
              type="button"
              className="text-sm focus:outline-none text-blue-500 hover:text-blue-700"
            >
              {t('PhysicianPagesLinkModal.personal_note.reset')}
            </button>
          </div>
          <div className="mt-6 flex flex-col">
            <Button
              className="self-end"
              type="submit"
              isDisabled={isSubmitDisabled}
              isLoading={isLoading}
            >
              {t('PhysicianPagesLinkModal.personal_note.button')}
            </Button>
          </div>
        </div>
      </form>
    </Modal>
  );
};

PhysicianPagesLinkModal.propTypes = {
  personalNote: PropTypes.string,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  isIndexed: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default PhysicianPagesLinkModal;
